module.exports = __webpack_public_path__ + "img/user-large-slash-solid.f9cfa682.svg";